@if (loading$ | async) {
  <div class="global-loader">
    <div class="whirly-loader"></div>
  </div>
}
